<template>
  <v-container class="home pa-0" fluid>
    <div class="hero-section">
      <div class="hero-content">
        <div class="hero-header">
          <h1 class="hero-title">Личный кабинет</h1>
          <p class="hero-subtitle">Управление домофонными системами</p>
          <p class="hero-subtitle-cc mt-2">Контактный центр: <b>27-87-87</b></p>
        </div>

        <div v-if="visibleHomePageBlocks.length > 0" class="partners-section">
          <h2 class="section-title">Новости и уведомления</h2>

          <div class="news-slider">
            <div
              class="news-track"
                 :class="{
                  'center-1': visibleHomePageBlocks.length === 1,
                  'center-2': visibleHomePageBlocks.length === 2
                }"
            >
              <div
                class="news-slide"
                v-for="(block, index) in visibleHomePageBlocks"
                :key="index"
              >
                <v-card class="partner-card" :class="`partner-card--${block.color || 'primary'}`">
                  <v-card-text class="partner-content">
                    <div v-if="block.date" class="partner-date-corner">
                      <v-icon small class="mr-1">mdi-calendar</v-icon>
                      <span>{{ block.date }}</span>
                    </div>
                    <div v-if="block.image" class="partner-image-icon" @click="openImage(block.image_url)">
                      <v-icon small>mdi-image</v-icon>
                    </div>
                    <div v-if="block.type" class="partner-type-corner">
                      <v-chip small :color="`${block.color || 'primary'}`" text-color="white">
                        {{ getTypeLabel(block.type) }}
                      </v-chip>
                    </div>
                    <div class="partner-icon">
                      <v-icon size="56" :color="block.color || 'primary'">
                        {{ block.icon || 'mdi-information' }}
                      </v-icon>
                    </div>
                    <h3 class="partner-title">{{ block.title }}</h3>
                    <p class="partner-description">{{ block.description }}</p>
                    <div class="partner-meta">
                      <div v-if="block.phone" class="partner-phone">
                        <v-icon small class="mr-1" color="primary">mdi-phone</v-icon>
                        <span class="phone-number">{{ block.phone }}</span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </div>
        </div>

        <!-- Навигационные кнопки -->
        <div class="navigation-section">
          <h2 class="section-title">Быстрый доступ</h2>
          <div class="nav-buttons">
            <v-btn
              v-for="page in visiblePageStore"
              :key="page.title"
              class="nav-btn"
              medium
              outlined
              :to="page.path"
              @mouseenter="activateShowSelect(page.title)"
              @mouseleave="deactivateShowSelect(page.title)"
            >
              <v-icon class="nav-btn-icon">{{ getIcon(page) }}</v-icon>
              <span class="nav-btn-text">{{ page.title }}</span>
            </v-btn>

            <!-- СКУД меню -->
            <v-menu
              v-if="roleName !== 'master' && roleName !== 'checkpoint-admin'"
              max-width="250"
              v-model="showAdditionalPagesMenu"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="nav-btn menu-btn"
                  medium
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  @mouseenter="rotateIcon(true)"
                  @mouseleave="rotateIcon(false)"
                >
                  <v-icon
                    class="nav-btn-icon"
                    :style="{ transform: `rotate(${rotation}deg)`, transition: 'transform 0.3s ease' }"
                  >
                    mdi-dots-vertical
                  </v-icon>
                  <span class="nav-btn-text">СКУД</span>
                </v-btn>
              </template>

              <v-list class="menu-list">
                <v-list-item
                  v-for="additionalPage in additionalPages"
                  :key="additionalPage.title"
                  class="menu-item"
                >
                  <v-btn
                    class="menu-btn-item"
                    medium
                    outlined
                    :to="additionalPage.path"
                    @mouseover="activateShowSelect(additionalPage.title)"
                    @mouseleave="deactivateShowSelect(additionalPage.title)"
                  >
                    <v-icon class="mr-3">{{ getIcon(additionalPage) }}</v-icon>
                    {{ additionalPage.title }}
                  </v-btn>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Home',
  data () {
    return {
      people: ['Men', 'Women', 'Both'],
      isRoleNameSelectively: true,
      activeButton: null,
      showAdditionalPagesMenu: false,
      rotation: 0,
      homePageBlocks: [],
      additionalPages: [
        {
          title: 'Домофоны',
          path: { name: 'Doorphone' },
          icon: 'mdi-doorbell-video',
          iconHover: 'mdi-door-open',
          show: true,
        },
        {
          title: 'Шлагбаумы',
          path: { name: 'Barriers' },
          icon: 'mdi-boom-gate-outline',
          iconHover: 'mdi-boom-gate-alert-outline',
          show: true,
        },
        {
          title: 'Калитки',
          path: { name: 'Gates' },
          icon: 'mdi-gate-alert',
          iconHover: 'mdi-gate-open',
          show: true,
        },
      ],
    };
  },
  created () {
    switch (this.roleName) {
      case 'manager' : case 'call-center' : case 'master' : case 'checkpoint-admin' :this.isRoleNameSelectively = false;
        break;
    }
    this.loadHomePageBlocks();
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
    }),
    ...mapGetters('Articles', ['articles']),
    visibleHomePageBlocks () {
      return this.homePageBlocks.filter(block => block.enabled && this.canSeeBlock(block));
    },
    visiblePageStore () {
      return this.pageStore.filter(page => page.show);
    },
    pageStore () {
      return [
        {
          title: 'Ключи доступа',
          path: { name: 'Access-keys' },
          icon: 'mdi-key',
          iconHover: 'mdi-key-wireless',
          show: this.roleName !== 'call-center' && this.roleName !== 'master' && this.roleName !== 'checkpoint-admin',
        },
        {
          title: 'Карта',
          path: { name: 'TheMap' },
          icon: 'mdi-google-maps',
          iconHover: 'mdi-map-marker-right-outline',
          show: this.roleName === 'admin',
        },
        {
          title: 'Жилые комплексы',
          path: { name: 'ResidentialComplexes' },
          icon: 'mdi-home-map-marker',
          iconHover: 'mdi-shield-home',
          show: this.roleName !== 'admin' && this.roleName !== 'master',
        },
        {
          title: 'Массовые функции',
          path: { name: 'MassFunction' },
          icon: 'mdi-cog-outline',
          iconHover: 'mdi-cog',
          show: this.isRoleNameSelectively,
        },
      ];
    },
  },
  methods: {
    ...mapActions('Articles', ['loadArticles']),
    canSeeBlock (block) {
      if (!block.roles || block.roles.length === 0) return true;
      return block.roles.includes(this.roleName);
    },
    activateShowSelect (title) {
      this.activeButton = title;
    },
    deactivateShowSelect () {
      this.activeButton = null;
    },
    getIcon (page) {
      return this.activeButton === page.title ? page.iconHover : page.icon;
    },
    rotateIcon (shouldRotate) {
      this.rotation = shouldRotate ? 180 : 0;
    },
    async loadHomePageBlocks () {
      try {
        await this.loadArticles();
        this.homePageBlocks = [...this.articles].sort((a, b) => b.id - a.id);
      } catch (e) {
        this.$flash_danger && this.$flash_danger('Ошибка загрузки статей');
      }
    },
    getTypeLabel (type) {
      const labels = {
        news: 'Новость',
        reminder: 'Памятка',
        marketing: 'Реклама',
        important: 'Важно',
        info: 'Информация',
      };
      return labels[type] || 'Новость';
    },
    openImage (imageUrl) {
      if (imageUrl) {
        window.open(imageUrl, '_blank');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  min-height: 100vh;
}

.hero-section {
  background: linear-gradient(300deg, rgba(91,19,110,1) 0%, rgba(49,62,129,1) 100%);
  min-height: 85vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.news-slider {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 15px;
  padding-top: 10px;
  margin-bottom: 30px;
  transition: all 0.3s ease;
  scroll-snap-type: x mandatory;
  touch-action: pan-x;

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    height: 8px;
    transition: opacity 0.3s ease;
    opacity: 0;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &:hover {
    scrollbar-width: thin;
    &::-webkit-scrollbar {
      opacity: 1;
    }
  }
}

.news-track {
  display: flex;
  gap: 16px;
}

.news-track.center-1 {
  justify-content: center;
}

.news-track.center-2 {
  justify-content: center;
}

.news-slide {
  flex: 0 0 calc(33.333% - 10.6px);
  max-width: calc(33.333% - 10.6px);
  scroll-snap-align: start;
}

.hero-content {
  max-width: 1200px;
  width: 100%;
  text-align: center;
}

  .hero-header {
    margin-bottom: 60px;

    .hero-title {
      color: white;
      font-size: 2.5rem;
      font-weight: 600;
      margin-bottom: 12px;
      text-shadow: 0 2px 4px rgba(0,0,0,0.3);
    }

    .hero-subtitle {
      color: rgba(255,255,255,0.9);
      font-size: 1.2rem;
      font-weight: 300;
    }
    .hero-subtitle-cc {
      color: white;
      font-size: 1.2rem;
    }
  }

  .section-title {
    color: white;
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 30px;
    text-shadow: 0 2px 4px rgba(0,0,0,0.3);
  }

  .partners-section {
    margin-bottom: 60px;
  }

  .partners-grid {
    margin-bottom: 30px;
  }

  .partner-card {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 16px;
    transition: all 0.3s ease;
    height: 100%;
    border: none;
    box-shadow: 0 4px 20px rgba(0,0,0,0.1);

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 12px 40px rgba(0,0,0,0.2);
      background: rgba(255, 255, 255, 1);
    }

    .partner-content {
      padding: 32px 24px;
      text-align: center;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: relative;
    }

    .partner-date-corner {
      position: absolute;
      top: 12px;
      right: 12px;
      display: flex;
      align-items: center;
      font-size: 0.8rem;
      color: #666;
      background: rgba(255, 255, 255, 0.9);
      padding: 4px 8px;
      border-radius: 12px;
      backdrop-filter: blur(4px);
    }

    .partner-image-icon {
      position: absolute;
      top: 12px;
      left: 80px; // Сдвигаем вправо от типа блока
      background: rgba(0, 0, 0, 0.1);
      padding: 6px;
      border-radius: 50%;
      cursor: pointer;
      transition: all 0.2s ease;
      z-index: 1;

      &:hover {
        background: rgba(0, 0, 0, 0.2);
        transform: scale(1.1);
      }

      .v-icon {
        color: #666;
      }
    }

    .partner-type-corner {
      position: absolute;
      top: 12px;
      left: 12px;
      z-index: 2; // Поверх других элементов
    }

    .partner-icon {
      margin-bottom: 20px;
    }

    .partner-title {
      font-size: 1.2rem;
      font-weight: 600;
      margin-bottom: 12px;
      color: #333;
    }

    .partner-description {
      font-size: 0.95rem;
      color: #666;
      line-height: 1.5;
      margin-bottom: 20px;
      flex-grow: 1;
    }

    .partner-meta {
      display: flex;
      flex-direction: column;
      gap: 8px;
      align-items: center;
    }

    .partner-phone {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.9rem;
      font-weight: 500;
      color: #666;
      padding: 8px 16px;
      background: rgba(0, 0, 0, 0.05);
      border-radius: 12px;

      .phone-number {
        color: #1976d2;
        font-weight: 600;
      }
    }

    .partner-type {
      display: flex;
      justify-content: center;
      margin-bottom: 8px;
    }

    .partner-image-btn {
      display: flex;
      justify-content: center;
      margin-top: 8px;
    }
  }

  .partner-card--primary {
    border-left: 4px solid #1976d2;
    .partner-icon { color: #1976d2; }
    .partner-date-corner { background: rgba(25, 118, 210, 0.1); }
  }

  .partner-card--success {
    border-left: 4px solid #4caf50;
    .partner-icon { color: #4caf50; }
    .partner-date-corner { background: rgba(76, 175, 80, 0.1); }
  }

  .partner-card--warning {
    border-left: 4px solid #ff9800;
    .partner-icon { color: #ff9800; }
    .partner-date-corner { background: rgba(255, 152, 0, 0.1); }
  }

  .partner-card--error {
    border-left: 4px solid #f44336;
    .partner-icon { color: #f44336; }
    .partner-date-corner { background: rgba(244, 67, 54, 0.1); }
  }

  .partner-card--purple {
    border-left: 4px solid #9c27b0;
    .partner-icon { color: #9c27b0; }
    .partner-date-corner { background: rgba(156, 39, 176, 0.1); }
  }

  .partner-card--teal {
    border-left: 4px solid #009688;
    .partner-icon { color: #009688; }
    .partner-date-corner { background: rgba(0, 150, 136, 0.1); }
  }

  .navigation-section {
    margin-top: 40px;
  }

  .nav-buttons {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    gap: 16px;
    max-width: 100%;
    margin: 2 auto;
    overflow-x: auto;
    padding: 10px 20px;
  }

  .nav-btn {
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba(255, 255, 255, 0.3);
    color: white;
    border-radius: 12px;
    padding: 12px 20px;
    min-width: 140px;
    flex-shrink: 0;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);

    &:hover {
      background: rgba(255, 255, 255, 0.2);
      border-color: rgba(255, 255, 255, 0.5);
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(0,0,0,0.2);
    }

    .nav-btn-icon {
      font-size: 1.2rem;
      margin-right: 12px;
    }

    .nav-btn-text {
      font-weight: 500;
      font-size: 0.9rem;
    }
  }

  .menu-btn {
    position: relative;
  }

  .menu-list {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  .menu-item {
    padding: 8px;
  }

  .menu-btn-item {
    width: 100%;
    background: transparent;
    color: #333;
    border: 1px solid rgba(0,0,0,0.1);
    border-radius: 8px;

    &:hover {
      background: rgba(25, 118, 210, 0.1);
      color: #1976d2;
    }
  }

  @media screen and (max-width: 960px) {
    .hero-title {
      font-size: 2.5rem;
    }

    .news-slide {
      flex: 0 0 50%;
      max-width: 50%;
      scroll-snap-align: start;
    }
    .news-track.center-1,
    .news-track.center-2 {
      justify-content: flex-start;
    }

    .section-title {
      font-size: 1.75rem;
    }

    .nav-buttons {
      justify-content: flex-start;
      padding: 0 10px;
    }

    .nav-btn {
      min-width: 120px;
      padding: 10px 16px;
    }
  }

  @media screen and (max-width: 600px) {
    .hero-section {
      padding: 20px 16px;
    }

    .hero-title {
      font-size: 2rem;
    }

    .hero-subtitle {
      font-size: 1rem;
    }

    .section-title {
      font-size: 1.5rem;
    }

    .partner-card .partner-content {
      padding: 24px 16px;
    }

    .partner-title {
      font-size: 1.1rem;
    }
    .news-slide {
      flex: 0 0 100%;
      max-width: 100%;
      scroll-snap-align: start;
    }
    .news-track.center-1,
    .news-track.center-2 {
      justify-content: flex-start;
    }
    .news-slider::-webkit-scrollbar {
      display: none;
    }
    .news-slider {
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
  }
</style>
